module.exports = __webpack_public_path__ + "static/img/智能合同管理平台.e56cdbdc.png";